<template>
    <!-- Submit Disclaimer Modal -->
    <transition name="modal">
        <div class="reveal-overlay">
            <div class="reveal" id="modal-submit-disclaimer" tabindex="-1" role="dialog">
                <div class="modal-header">
                    <h4 class="modal-title">
                        SUBMIT PROJECT
                    </h4>
                    <button class="close-button" aria-label="Close modal" type="button" @click="$emit('close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                            <div class="small-12 columns">
                                    <p>This is your last chance to make any changes to your script!
Any changes you make after checking out may incur additional charges.
You will be responsible for any errors or omissions in the script or lack of specific pronunciation notes.</p>
                            </div>
                    </div>
                </div>

                <!-- Modal Actions -->
                <div class="modal-footer">
                    <router-link class="button float-left" :to="{name: 'project_id', params: {id: $route.params.id}}">MAKE CHANGES</router-link>
                    <button type="button" class="button float-right" @click="store">
                        SUBMIT
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['parent'],
        data() {
            return {
                
                errors: []
            }
        },
        methods: {
            store: function() {
                
            },
        }
    }
</script>


// WEBPACK FOOTER //
// prompts/components/modals/SubmitDisclaimer.vue